// 抄控管理路由

const MeterControlMana = [
    // 设备分组
    {
        path: '/equipment',
        component: resolve => require(['@/views/MeterControlMana/EquipmentGroup/EquipmentGroup'], resolve),
        name: 'equipmentGroup',
        meta: { title: '分组管理', breadcrumb: [{ menu: 'equipmentGroup' }], role: 'device_control' }
    },
    // 添加设备到分组
    {
        path: '/equipment/addmeter/:groupId',
        component: resolve => require(['@/views/MeterControlMana/EquipmentGroup/AddEquipment/AddEquipment'], resolve),
        name: 'addequipmentGroup',
        meta: { title: '设备分组', breadcrumb: [{ menu: 'equipmentGroup', path: '/equipment' }, { menu: 'addEquipment' }], role: 'device_control' }
    },
    // 报警设置
    // {
    //     path: '/alarmset',
    //     component: resolve => require(['@/views/MeterControlMana/WarningSetting/WarningSetting'], resolve),
    //     name: 'alarmset',
    //     meta: { title: '报警设置', breadcrumb: [{ menu: 'alarmset' }], role: 'time_control' }
    // },
    // 群控管理 计费系统
    {
        path: '/clustermana',
        component: resolve => require(['@/views/MeterControlMana/GroupControlMana/GroupControlMana'], resolve),
        name: 'clustermana',
        meta: { title: '群控管理', breadcrumb: [{ menu: 'clustermana' }], role: 'device_control' }
    },
    // 群控管理 控制系统
    {
        path: '/clustermana1',
        component: resolve => require(['@/views/MeterControlMana/GroupControlMana/GroupControlMana1'], resolve),
        name: 'clustermana1',
        meta: { title: '群控管理', breadcrumb: [{ menu: 'clustermana' }], role: 'device_control' }
    },
    // 计费模式
    {
        path: '/billingmode',
        component: resolve => require(['@/views/MeterControlMana/BillingMode/BillingMode'], resolve),
        name: 'billingmode',
        meta: { title: '计费模式', breadcrumb: [{ menu: 'billingmode' }], role: 'device_control' }
    },
    // 定时管理
    {
        path: '/timing',
        component: resolve => require(['@/views/MeterControlMana/TimingMana/TimingMana'], resolve),
        name: 'timing',
        meta: { title: '定时管理',  breadcrumb: [{ menu: 'timing' }], role: 'time_control' }
    },
    // 添加定时
    {
        path: '/timing/addtiming/:timingId',
        component: resolve => require(['@/views/MeterControlMana/TimingMana/AddTiming/AddTiming'], resolve),
        name: 'addTiming',
        meta: { title: '定时设置', breadcrumb: [{ menu: 'timing', path: "/timing" }, { menu: 'addTiming' }], role: 'time_control' }
    },
    // 欠费管理
    {
        path: '/arrearagemana',
        component: resolve => require(['@/views/MeterControlMana/DisableMana/DisableMana'], resolve),
        name: 'arrearagemana',
        meta: { title: '欠费管理', breadcrumb: [{ menu: 'arrearagemana' }] }
    },
    // 运行状态
    // {
    //     path: '/running',
    //     component: resolve => require(['@/views/MeterControlMana/RunningStatus/RunningStatus'], resolve),
    //     name: 'running',
    //     meta: { title: '运行状态', breadcrumb: [{ menu: 'running' }] }
    // },
];

export default MeterControlMana